<template>
  <section class="page-section page-section--item bg-light-brown py-4 mt-0 mb-2">
    <div class="container">
      <div class="row">
        <div class="col-5">
          <div class="item__img">
            <picture class="swiper-slider__img mb-3">
              <img :src="`/storage/${item.image}`" :alt="item.title" class="img-fluid">
            </picture>
          </div>
        </div>

        <div class="col-7">
          <div class="item__content mt-2">
            <p class="item__name fw-bold"> {{ item.title }}</p>
            <!--            <p class="item__price-bid mb-0">€ 0,20 Geboden</p>-->
            <!--            <p class="item__price-total">€ 2,00 Totaal </p>-->
          </div>
        </div>

      </div>
      <div>
      </div>
    </div>
  </section>

  <section class="page-section page-section--auction mt-0 mb-0">
    <div class="justify-content-center text-center">
      <p class="fw-bold"> Uw kopersnummer: {{ store.number }}</p>
    </div>
  </section>

  <ActionBtn :status="status" @buy="purchase"></ActionBtn>

</template>
<script>
import {visitor} from '../../stores/visitor';
import ActionBtn from "../general/ActionBtn";

export default {
  components: {
    ActionBtn,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const store = visitor()
    return {
      store,
    }
  },
  data() {
    return {
      status: 'start',
      price: 100,
      clock: '',
      lastItem: this.item,
    };
  },
  mounted() {
    this.setStatus(this.item);
    this.listen();
    this.getPurchases();
  },
  methods: {
    purchase() {
      if(this.price < this.item.range_min || this.price > this.item.range_max) {
        this.status = 'early';
        const event = Echo.private('auction-channel-' + this.item.auction_id)
          .whisper('missed', {
          'timeStamp': Date.now(),
          'id': this.store.id,
          'name': this.store.name,
          'number': this.store.number,
          'item_id': this.item.id,
          'pivot': {
            'auction_attendee_id': this.store.id,
            'price': this.price * this.item.unit
          }
        })
      } else {
        const event = Echo.private('auction-channel-' + this.item.auction_id)
        .whisper('buy', {
          'timeStamp': Date.now(),
          'id': this.store.id,
          'name': this.store.name,
          'number': this.store.number,
          'item_id': this.item.id,
          'pivot': {
            'auction_attendee_id': this.store.id,
            'price': this.price * this.item.unit
          }
        })
        clearInterval(this.clock);
      }
    },
    setStatus(item){
      this.status =
        item.purchased_by[0] && item.purchased_by[0].id == this.store.id ? 'win'
          : this.store.itemLimit? 'max'
            : item.purchased_by.length == 0 ? 'start'
                  : this.status != 'early' ? 'late' : 'early';
    },
    countdown() {
      this.price -= 1;
      if (this.price <= 0) {
        this.price = 100;
        if(this.status != 'early') {
          this.status = 'late'
        }
        clearInterval(this.clock);
      }
    },
    listen() {
      const test = Echo.channel('auction-channel-' + this.item.auction_id)
          .listen('.item.auction.active', (e) => {
              this.setStatus(e.auctionItem);
            this.price = 100;
            this.getPurchases();
          })
      const event = Echo.private('auction-channel-' + this.item.auction_id)
          .listenForWhisper('start', (e) => {
            if(!this.store.itemLimit){
              this.status = 'running';
            }
              this.clock = setInterval(this.countdown, 50);
          })
          .listenForWhisper('stop', (e) => {
              if(!this.store.itemLimit){
                this.status = 'pauze';
              }
              clearInterval(this.clock);
          })
          .listenForWhisper('restart', (e) => {
            if(!this.store.itemLimit){
              this.status = 'start';
              this.price = 100;
            }
              clearInterval(this.clock);
          })
          .listenForWhisper('purchase_confirm', (e) => {
              this.price = 100;
              this.item.purchased_by[0] = e;
              this.setStatus(this.item);
          })
    },
    getPurchases() {
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
      axios({
        method: 'GET',
        url: '/api/auction/'+this.item.auction_id+'/purchases/' + this.store.id,
        data: {'X-CSRF-TOKEN': csrfToken},
      })
        .then(response => {
          if (response.data.status &&
            response.data.status == 'success' &&
            response.data.data) {
              this.store.itemLimit = response.data.data.purchases >= response.data.data.max_items_per_attendee ? true : false;
          }
          else{
            this.store.itemLimit = false;
          }
          this.setStatus(this.item);
        });
    }
  }
}
</script>
